import { toast } from "@loot-os/ui/components/sonner";
import { MutationCache, QueryClient } from "@tanstack/react-query";

/**
 * Module-scope query client so non-React modules (lib/tenantScope.ts) can clear
 * the cache when the route's tenant scope changes.
 *
 * Every failed mutation is announced here, as a toast, so no router renders
 * `mutation.error` itself: the message reaches the user without a banner
 * appearing in the page and pushing the form down.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => {
      toast.error(error.message);
    },
  }),
});
